module.exports = __webpack_public_path__ + "static/media/social-network.29884832.jpg";